import React, {useState, useEffect} from 'react';
import { useWeb3 } from '@openzeppelin/network/react';

import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { useWeb3React } from '@web3-react/core'
import { InjectedConnector } from '@web3-react/injected-connector'

import {formatEther} from "@ethersproject/units";

import { Contract } from '@ethersproject/contracts'
import { isAddress } from '@ethersproject/address'

import useSWR from 'swr'


export const fetcher = (library, abi = null) => (...args) => {

    console.log(`Fetcher..`);

    const [arg1, arg2, ...params] = args
    // it's a contract
    if (isAddress(arg1)) {
      const address = arg1
      const method = arg2
      const contract = new Contract(address, abi, library.getSigner())
      return contract[method](...params)
    }
    // it's a eth call
    const method = arg1
    return library[method](arg2, ...params)
  }